export const PENDO_TRACK_EVENTS = {
    REPHRASE: 'spacesAI_rephrase',
    TICKET_SUMMARY_AND_SENTIMENT_DISPLAYED: 'spacesAI_ticket_summary_and_sentiment_displayed',
    TICKET_SUMMARY_ERROR: 'spacesAI_ticket_summary_error',
    SUGGESTED_CATEGORY_CHECKED: 'spacesAI_suggested_category_checked',
    SUGGESTED_CATEGORY_SELECTED: 'spacesAI_suggested_category_selected',
    CUSTOM_COLUMN_ADD_TO_TEMPLATE: 'CUSTOM_COLUMN_ADD_TO_TEMPLATE',
    CUSTOM_COLUMN_REMOVE_FROM_TEMPLATE: 'CUSTOM_COLUMN_REMOVE_FROM_TEMPLATE',
    CUSTOM_COLUMN_POPULATED: 'CUSTOM_COLUMN_POPULATED',
    ACTIVITIES_CLICKED: 'ACTIVITIES_CLICKED',
    ACTIVITY_SUBMITTED: 'ACTIVITY_SUBMITTED',
    ACTIVITY_DELETED: 'ACTIVITY_DELETED',
    TICKET_MISSING_REQUIRED_FIELDS: 'TICKET_MISSING_REQUIRED_FIELDS',
    SWITCH_TO_CLASSIC_FEEDBACK: 'SWITCH_TO_CLASSIC_FEEDBACK',
    ADD_NEW_COLUMN: 'ADD_NEW_COLUMN',
    DELETE_COLUMN: 'DELETE_COLUMN',
    EDITE_COLUMN_FILDS: 'EDITE_COLUMN_FILDS', // check if needed
    OPEN_IN_CLASSIC_WAS_CLICKED: 'OPEN_IN_CLASSIC_WAS_CLICKED',
    DELETE_TICKT_WAS_CLICKED: 'DELETE_TICKT_WAS_CLICKED',
    SET_TEMPLATE_AS_DEFAULT_WAS_CLICKED: 'SET_TEMPLATE_AS_DEFAULT_WAS_CLICKED',
    DOPLICATE_TEMPLATE_WAS_CLICKED: 'DOPLICATE_TEMPLATE_WAS_CLICKED',
    DELETE_TEMPLATE_WAS_CLICKED: 'DELETE_TEMPLATE_WAS_CLICKED',
};
